'use strict';

class IdeaState {
    constructor(name, color, released) {
        this._name = name;
        this._color = color;
        this._released = released;
    }

    get name() {
        return this._name;
    }

    get color() {
        return this._color;
    }

    toString() {
        return this._name;
    }

    isReleased() {
        return !!this._released;
    }

    isNotReleased() {
        return !this.isReleased();
    }
}

const states = [
    new IdeaState('new', '#F44336', false),
    new IdeaState('accepted', '#FF9800', false),
    new IdeaState('designing', '#9C27B0', false),
    new IdeaState('working', '#2196F3', false),
    new IdeaState('releaseWaiting', '#85AF15', false),
    new IdeaState('released', '#4CAF50', true),
    new IdeaState('closed', '#009688', false),
    new IdeaState('wontfix', '#9E9E9E', false),
];

module.exports = states;



// WEBPACK FOOTER //
// ./feedback/domain/value/idea-state.js